// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    width: 100%;
    height: 100vh;
    margin: 0;
    font-family: "Nunito Sans ", sans-serif;
}

.body-heading {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

.pricing {
    margin: 25px 0;
}

.yearly-monthly {
    padding: 5px;
    display: flex;
    margin: 10px auto;
    width: fit-content;
    background: #DDEBF8;
    border-radius: 50px;
}

.yearly-monthly span {
    border-radius: 50px;
    padding: 5px 20px;
    cursor: pointer;
}

.save-upto {
    color: #1976D2;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}

.pricing-header-row {
    width: 47%;
    display: flex;
    margin-left: auto;
    margin-right: 12%;
    justify-content: space-between;
}

.pricing-buttons-row {
    width: 43%;
    display: flex;
    margin: 30px 10% 30px auto;
    justify-content: space-between;
}

.pricing-body-row {
    width: 80%;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    border-bottom: 1px solid #BDBDBD;
}

.pricing-body-row h3 {
    width: 10%;
    text-wrap: nowrap;
    text-align: center;
    font-weight: normal;
}

.pricing-body-row img {
    width: 25px;
}

.pricing-body-row .info {
    width: 30%;
}

.pricing-body-row .info h3 {
    width: auto;
    margin: 10px 0;
    text-align: initial;
}

.pricing-body-row .info p {
    font-size: 14px;
    color: #4D4D4D;
}

.pricing-header-row h2 {
    margin: 10px 0;
    color: #004BA0;
}

.pricing-header-row span {
    color: #4D4D4D;
    font-size: 18px;
    font-weight: bold;
}

@media screen and (max-width: 600px) {
    .body-heading {
        width: 80%;
        margin: auto;
        text-align: center;
    }

    .body-heading h1 {
        font-size: 28px;
    }

    .body-heading span {
        font-size: 17px;
    }

    .pricing-header-row {
        width: 90%;
        margin: auto;
    }

    .pricing-header-row .header-cell {
        width: 25%;
        text-align: center;
    }

    .pricing-header-row h2 {
        color: #212121;
        font-size: 20px;
        font-weight: normal;
    }

    .amount-mobile {
        color: #004BA0;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
    }

    .pricing-body-row {
        width: 90%;
    }

    .pricing-body-row .info {
        width: 80%;
    }

    .pricing-body-row h3 {
        width: 30%;
        text-wrap: initial;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pricing-page/css/pricing-body.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":["body {\n    width: 100%;\n    height: 100vh;\n    margin: 0;\n    font-family: \"Nunito Sans \", sans-serif;\n}\n\n.body-heading {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.pricing {\n    margin: 25px 0;\n}\n\n.yearly-monthly {\n    padding: 5px;\n    display: flex;\n    margin: 10px auto;\n    width: fit-content;\n    background: #DDEBF8;\n    border-radius: 50px;\n}\n\n.yearly-monthly span {\n    border-radius: 50px;\n    padding: 5px 20px;\n    cursor: pointer;\n}\n\n.save-upto {\n    color: #1976D2;\n    font-size: 16px;\n    font-weight: bold;\n    text-align: center;\n}\n\n.pricing-header-row {\n    width: 47%;\n    display: flex;\n    margin-left: auto;\n    margin-right: 12%;\n    justify-content: space-between;\n}\n\n.pricing-buttons-row {\n    width: 43%;\n    display: flex;\n    margin: 30px 10% 30px auto;\n    justify-content: space-between;\n}\n\n.pricing-body-row {\n    width: 80%;\n    display: flex;\n    margin: 0 auto;\n    justify-content: space-between;\n    border-bottom: 1px solid #BDBDBD;\n}\n\n.pricing-body-row h3 {\n    width: 10%;\n    text-wrap: nowrap;\n    text-align: center;\n    font-weight: normal;\n}\n\n.pricing-body-row img {\n    width: 25px;\n}\n\n.pricing-body-row .info {\n    width: 30%;\n}\n\n.pricing-body-row .info h3 {\n    width: auto;\n    margin: 10px 0;\n    text-align: initial;\n}\n\n.pricing-body-row .info p {\n    font-size: 14px;\n    color: #4D4D4D;\n}\n\n.pricing-header-row h2 {\n    margin: 10px 0;\n    color: #004BA0;\n}\n\n.pricing-header-row span {\n    color: #4D4D4D;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n@media screen and (max-width: 600px) {\n    .body-heading {\n        width: 80%;\n        margin: auto;\n        text-align: center;\n    }\n\n    .body-heading h1 {\n        font-size: 28px;\n    }\n\n    .body-heading span {\n        font-size: 17px;\n    }\n\n    .pricing-header-row {\n        width: 90%;\n        margin: auto;\n    }\n\n    .pricing-header-row .header-cell {\n        width: 25%;\n        text-align: center;\n    }\n\n    .pricing-header-row h2 {\n        color: #212121;\n        font-size: 20px;\n        font-weight: normal;\n    }\n\n    .amount-mobile {\n        color: #004BA0;\n        font-size: 24px;\n        font-weight: bold;\n        text-align: center;\n    }\n\n    .pricing-body-row {\n        width: 90%;\n    }\n\n    .pricing-body-row .info {\n        width: 80%;\n    }\n\n    .pricing-body-row h3 {\n        width: 30%;\n        text-wrap: initial;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
